// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"2dcd6798","787":"5d4722d8","797":"025e29a0"}[chunkId] + ".chunk.js";
};